// removed by extract-text-webpack-plugin
module.exports = {"component":"Collapsible__component___6_zS3","title":"Collapsible__title___3hv2i","titleOpen":"Collapsible__titleOpen___12ovL","content":"Collapsible__content___3mmjL"};


//////////////////
// WEBPACK FOOTER
// ./src/admin/components/Collapsible.css
// module id = 398
// module chunks = 0